import type { Resolver } from '@urql/exchange-graphcache';

const resolvers: {
  [key: string]: {
    [key: string]: Resolver;
  };
} = {
  query_root: {
    badge_by_pk: (_, args) => ({ __typename: 'badge', id: args.id }),
    badge_assignee_by_pk: (_, args) => ({
      __typename: 'badge_assignee',
      id: args.id,
    }),
    team_by_pk: (_, args) => ({ __typename: 'team', id: args.id }),
    event_by_pk: (_, args) => ({ __typename: 'event', id: args.id }),
    tag_group_by_pk: (_, args) => ({ __typename: 'tag_group', id: args.id }),
    chat_by_pk: (_, args) => ({ __typename: 'chat', id: args.id }),
    message_by_pk: (_, args) => ({ __typename: 'message', id: args.id }),
    person_by_pk: (_, args) => ({ __typename: 'person', id: args.id }),
  },
};

export default resolvers;
